module.exports = __webpack_public_path__ + "static/pouyanic-complete-0ce9a0b278321544413ef41cf21ee28b.jpg";